































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IRoom, IRoomControl } from "@/@types/hotel/room";
import { adjustColor } from "@/services/_shared/color";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { ICruise } from "@/@types/cruiseOffers/cruiseList";

import GuestSortCruise from "./sorts/guest-sort-cruise.vue";
import StandartModal from "@/components/app/standart-modal.vue";

interface IRoomLeavel {
  [x: string]: Array<Array<string>>;
}

@Component({ components: { StandartModal, GuestSortCruise } })
export default class ChoiceDropVroom extends Vue {
  @Prop({ type: Array, default: () => [] }) rooms!: Array<IRoom>;
  @Prop({ type: Array, default: () => [] }) roomLevels!: Array<IRoomControl>;
  @Prop({ type: Array, default: () => [] }) virtualRooms!: Array<IVirtualRooma>;
  @Prop({ type: Array, default: () => [] }) cruises!: Array<ICruise>;
  @Prop({ type: Array, default: () => [] }) cruiseCodes!: Array<string>;
  waif: Array<IRoom> = [];
  width = 2;

  dropRooms: Array<string> = [];

  get roomList(): IRoomLeavel {
    const levels: IRoomLeavel = {};
    this.waif = [];
    const levels_id: Array<string> = [];
    this.roomLevels.forEach((el) => levels_id.push(el._id));

    const maximus: { [x: string]: { x: string; y: string } } = {};
    let maxx = 0;
    this.rooms.forEach((el) => {
      if (
        el.level &&
        el.position &&
        el.position.x !== null &&
        el.position.x !== undefined &&
        el.position.y !== null &&
        el.position.y !== undefined &&
        levels_id.includes(el.level)
      ) {
        const x =
          maximus[el.level] && maximus[el.level].x
            ? parseInt(maximus[el.level].x) < parseInt(el.position.x)
              ? el.position.x
              : maximus[el.level]?.x
            : String(0);
        const y =
          maximus[el.level] && maximus[el.level].y
            ? parseInt(maximus[el.level].y) < parseInt(el.position.y)
              ? el.position.y
              : maximus[el.level]?.y
            : String(0);
        maximus[el.level] = { x, y };

        maxx = maxx < parseInt(x) ? parseInt(x) : maxx;
      }
    });

    this.width = 100 / (maxx + 1) > 6 ? 6 : 100 / (maxx + 1);
    if (!Object.keys(maximus).length) return levels;

    this.roomLevels.forEach((el) => {
      const y = maximus[el._id] ? parseInt(maximus[el._id].y) : 0;
      const x = maximus[el._id] ? parseInt(maximus[el._id].x) + 1 : 0;

      this.roomLevels.forEach((el) => levels_id.push(el._id));
      levels[el._id] = new Array(y ? y + 1 : 0);
      for (let i = 0; i < levels[el._id].length; i++) {
        this.$set(levels[el._id], i, new Array(x ? x : 0).join("*").split(""));
      }
    });

    this.rooms.forEach((el) => {
      if (
        !el.level ||
        !el.position ||
        el.position.x === null ||
        el.position.x === undefined ||
        el.position.y === null ||
        el.position.y === undefined ||
        !levels_id.includes(el.level)
      )
        this.waif.push(el);
      else {
        const x = parseInt(el.position.x);
        const y = parseInt(el.position.y);

        let j = 0;
        while (!levels[el.level][y]) {
          if (j > 5) {
            break;
          }
          j++;
          levels[el.level].push([]);
        }

        let i = 0;
        while (!levels[el.level][y][x]) {
          if (i > 250) {
            break;
          }
          i++;
          levels[el.level][y].push("*");
        }
        levels[el.level][y][x] = JSON.parse(JSON.stringify(el._id));
      }
    });
    return levels;
  }

  async dropCruiseGuests(code: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.tc("Guests.List.buttons.delete", 2)),
        }
      );

      if (result === true) {
        this.$emit("deleteGuests", code);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  dropVRooms(): void {
    const vrooms: Array<string> = [];
    this.dropRooms.forEach((room) => {
      const vr = this.virtualRooma(room);
      if (vr) vrooms.push(vr._id);
    });
    this.$emit("dropVroom", vrooms);
  }

  changeDropVRoomsList(id: string): void {
    const vroom = this.virtualRooma(id);
    if (!vroom) return;

    const i = this.dropRooms.findIndex((vrid) => vrid == id);
    if (i < 0) this.dropRooms.push(id);
    else this.dropRooms.splice(i, 1);
  }

  getLevelName(id: string): string {
    const level = this.roomLevels.find((el) => el._id == id);
    return level ? this.$getLocale(level.name) : "-";
  }

  getRoom(room_id: string): Partial<IRoom> {
    const room = this.rooms.find((el) => el._id == room_id);
    return room ? room : { _id: room_id };
  }

  mouseover(level: string, room_id: string): void {
    const div = document.getElementById("choice-drop-vroom-" + level + room_id);
    if (!div) return;
    div.style.backgroundColor = this.bg(room_id)
      ? adjustColor(this.bg(room_id), 20)
      : "";
  }

  mouseleave(level: string, room_id: string): void {
    const div = document.getElementById("choice-drop-vroom-" + level + room_id);
    if (!div) return;
    div.style.background = this.bg(room_id);
  }

  bg(id: string): string {
    const room = this.rooms.find((el) => el._id == id);
    if (!room) return "";
    const vrooma = this.virtualRooms.find((el) => el.room == room._id);
    if (!vrooma) return "#f5f5f5";
    return "#ffcdd2";
  }

  virtualRooma(roomid: string | undefined): IVirtualRooma | undefined {
    return this.virtualRooms.find((vr) => vr.room == roomid);
  }
}
